import { generatePath } from 'react-router';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FullViewportScroll } from '@sorare/core/src/atoms/container/FullViewportScroll';
import { StarBall } from '@sorare/core/src/atoms/icons/StarBall';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { LabelM } from '@sorare/core/src/atoms/typography';
import {
  ANY_SPORT_SCOUTING_CENTER_STATS,
  FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSo5Competitions } from '@sorare/core/src/hooks/useSo5Competitions';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import {
  buildMarketTabRoute,
  useNavigableMarketTabParams,
} from '@sorare/marketplace/src/hooks/useNavigableMarketTabParams';

const So5CompetitionLogo = styled.img`
  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  object-fit: contain;
`;

const StyledTabBar = styled(TabBar)`
  --bar-bg-color-custom: transparent;
  &.flat {
    --bar-border-bottom: 0px solid var(--c-nd-100);
  }
  @media ${tabletAndAbove} {
    --bar-gap-custom: var(--unit);
  }
`;

export const ScoutingCenterBySo5Competition = () => {
  const { filterQuery } = useNavigableMarketTabParams();
  const { defaultSo5Competition, scoutableSo5Competitions } =
    useSo5Competitions();

  return (
    <FullViewportScroll>
      <StyledTabBar variant="flat" fullWidth ignoreQueryParams>
        <Tab
          key={defaultSo5Competition.slug}
          to={buildMarketTabRoute(
            generateSportPath(ANY_SPORT_SCOUTING_CENTER_STATS, {
              sport: Sport.FOOTBALL,
            }),
            filterQuery
          )}
        >
          <Vertical gap={1} center className="text-center">
            <StarBall color="currentColor" />
            <LabelM bold>{defaultSo5Competition.displayName}</LabelM>
          </Vertical>
        </Tab>
        {scoutableSo5Competitions.map(so5Competition => (
          <Tab
            key={so5Competition.slug}
            to={buildMarketTabRoute(
              generatePath(
                FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG,
                {
                  slug: so5Competition.slug,
                }
              ),
              filterQuery
            )}
          >
            <Vertical gap={1} center className="text-center">
              <So5CompetitionLogo src={so5Competition.iconUrl} />
              <LabelM bold>{so5Competition.displayName}</LabelM>
            </Vertical>
          </Tab>
        ))}
      </StyledTabBar>
    </FullViewportScroll>
  );
};
